function removeComingSoonItem() {
    let updates = {};
  
    const maincartItems = document.querySelector('cart-items');
    const miniCartItems = document.querySelector('cart-drawer-items');
    const cartItems = maincartItems || miniCartItems;
    const comingSoonItems = cartItems.querySelectorAll('[data-coming-soon]');
  
    comingSoonItems.forEach(item => {
      const variantId = +item.getAttribute('data-coming-soon');
      updates[variantId] = 0;
    })
    
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
    .then(response => {
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}
    